import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
`;

export const SummaryValue = styled.div`
  font-family: ${defaultTheme.fonts.title};
  font-size: 1.4rem;
  font-weight: 700;
  color: ${defaultTheme.colors["base-dark"]};
`;

export const SummaryLabel = styled.div`
  font-size: 0.75rem;
  color: ${defaultTheme.colors["gray-300"]};
`;

export const Badge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${defaultTheme.colors["white-100"]};
  background: ${({ color }) => color};
`;
